import React from "react";
import { useCore } from "@spectral-finance/react-core";
import { Box, BoxType } from "../../../Box";
import Flex from "../../../Flex";
import Spinner from "../../../Spinner";
import * as SC from "./VerifySignature.styles";
import SignatureLogo from "../../../../assets/sign.svg";
import useMediaQuery from "../../../../hooks/useMediaQuery";

export const VerifySignature = () => {
  const { web3 } = useCore();
  const isMobile = useMediaQuery("(max-width: 600px)");
  return (
    <Flex
      width="100%"
      height={isMobile ? "100%" : "250px"}
      column
      align="center"
      justify="center"
    >
      <Flex height="200px" align="center" justify="between" column>
        <Spinner size="m" />
        <h1>{web3.isChainId ? 'Verifying ownership...' : 'Wrong network'}</h1>
        <Box type={BoxType.ROUNDED_BORDER} width="100%" height="92px">
          <Flex align="center" justify="center">
            <img src={SignatureLogo} alt="Spectral Logo" />
            <SC.SignatureDescription>
              {web3.isChainId
                ? 'The signiture process is for verifying ownership of your wallet'
                : 'Before signing you need to switch to the correct network'}
            </SC.SignatureDescription>
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
};
